import { twMerge } from "tailwind-merge";

import ChevronLeft from "./ChevronLeft";

const ChevronRight = ({ className }: { className?: string }) => {
  return <ChevronLeft className={twMerge("rotate-180", className)} />;
};

export default ChevronRight;
